import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { logout } from "../actions";
import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import { matchPath } from "react-router";
import { Switch, Route, NavLink } from "react-router-dom";
import appRoutes from "../routes/app";
import logo from "../assets/bkg-white-logo-reg-vivescia.svg";
import ErrorMessage from "../components/common/ErrorMessage";
import PrivateRoute from "../components/common/PrivateRoute";
import ByEdfSf from "../components/common/byEdfSf";

const styles = theme => ({
  "@global": {
    body: {
      backgroundColor: "#f7f7f7"
    }
  },
  root: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column'
  },
  appBar: {
    position: "relative",
    //backgroundColor: "#ffffff",
    borderBottom: "1px solid #efefef",
    boxShadow: "none",
    minHeight: 60,
    backgroundColor: "#001a70",
    color: "#ffffff"
  },
  toolbarTitle: {
    flex: 1
  },
  layout: {
    width: "auto",
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    [theme.breakpoints.up(900 + theme.spacing(3 * 2))]: {
      width: 900,
      marginLeft: "auto",
      marginRight: "auto"
    }
  },
  heroContent: {
    maxWidth: 600,
    margin: "0 auto",
    padding: `${theme.spacing(8)}px 0 ${theme.spacing(6)}px`
  },
  cardHeader: {
    backgroundColor: theme.palette.grey[200]
  },
  cardPricing: {
    display: "flex",
    justifyContent: "center",
    alignItems: "baseline",
    marginBottom: theme.spacing(2)
  },
  cardActions: {
    [theme.breakpoints.up("sm")]: {
      paddingBottom: theme.spacing(2)
    }
  },
  footer: {
    marginTop: theme.spacing(8),
    borderTop: `1px solid ${theme.palette.divider}`,
    padding: `${theme.spacing(6)}px 0`
  },
  icon: {
    marginRight: theme.spacing(1)
  },
  item: {
    textDecoration: "none",
    marginRight: 5
  },
  itemLink: {
    transition: "all 300ms linear",
    borderRadius: "3px",
    position: "relative",
    color: "#ffffff",
    backgroundColor: "transparent",
    fontSize: "0.775rem",
    paddingRight: 8,
    paddingLeft: 8,
    "&:hover": {
      backgroundColor: theme.palette.secondary.main
    },
    ".active &": {
      backgroundColor: theme.palette.secondary.main
    }
  }
});

class Dashboard extends Component {
  handleLogout = () => {
    this.props.logout();
  };

  render() {
    const { classes } = this.props;

    const links = (
      <div>
        {this.props.error.open && <ErrorMessage/>}
        {appRoutes.map((prop, key) => {
          if (prop.redirect || !prop.isSidebar) return null;

          return (
            <NavLink
              to={prop.navbarTo || prop.path}
              className={`${classes.item} ${prop.className}`}
              activeClassName="active"
              key={key}
              isActive={(match, location) => {
                return match || matchPath(
                  location.pathname,
                  {
                    path: prop.path,
                    exact: true
                  }
                );
              }}
            >
              <Button className={classes.itemLink}>
                <prop.icon className={classes.icon}/>
                {prop.sidebarName}
              </Button>
            </NavLink>
          );
        })}
      </div>
    );

    return (
      <React.Fragment>
        <CssBaseline/>
        <AppBar position="static" color="default" className={classes.appBar}>
          <Toolbar>
            <Typography
              variant="h6"
              color="inherit"
              noWrap
              className={classes.toolbarTitle}
            >
              <img
                alt="Malteurop Groupe VIVESCIA"
                src={logo}
                style={{
                  display: 'inline-block',
                  verticalAlign: 'bottom',
                  height: 46
                }}
                onClick={() => {
                  this.props.history.push("/dashboard");
                }}
              />

              <ByEdfSf />
            </Typography>

            {links}
            <Button
              id="logout-button"
              onClick={this.handleLogout}
              variant="outlined"
              color="secondary"
            >
              Logout
            </Button>
          </Toolbar>
        </AppBar>
        <main className={classes.root}>
          <Switch>
            {appRoutes.map((prop, key) => {
              return prop.private ? (
                  <PrivateRoute path={prop.path} component={prop.component} key={key}/>
                ) :
                <Route path={prop.path} component={prop.component} key={key}/>;
            })}
          </Switch>
        </main>
      </React.Fragment>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = (state, ownProps) => ({
  error: state.error
});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    { logout }
  )(Dashboard)
);



// WEBPACK FOOTER //
// ./src/layout/Dashboard.js